import React from 'react';
import styles from './vervBar.module.scss';
import vervLogo from '../img/verv-logo.svg';

function VervBar() {
  return (
    <div className={styles.vervBar}>
			  <img src={vervLogo} alt="verv"/>
    </div>
  );
}

export default VervBar;
